import { atom } from 'jotai';
import { getCollapseCookie, getSpellcheckDisabled, setCollapseCookie, setSpellcheckDisabled } from '~/helpers/cookies';

const collapsedAtom = atom(getCollapseCookie());

export const collapsedWithCookieAtom = atom(
  (get) => get(collapsedAtom),
  (get, set, update) => {
    setCollapseCookie(update);
    set(collapsedAtom, update);
  }
);

const spellcheckDisabledAtom = atom(getSpellcheckDisabled());

export const spellcheckDisabledWithCookieAtom = atom(
  (get) => get(spellcheckDisabledAtom),
  (get, set, update) => {
    setSpellcheckDisabled(update);
    set(spellcheckDisabledAtom, update);
  }
);

// Focus mode atom - permet de cacher le header
export const focusModeAtom = atom(false);

// Header title atom - titre dynamique affiché à côté du burger
export const headerTitleAtom = atom('');
